import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../Components/Navbar/Navbar';
import NewsItem from '../Components/SquareBlocks/NewsItem';
import Footer from '../Components/Footer/Footer';
import './News.css';

const News = () => {
  const { t } = useTranslation('news');
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedNews, setSelectedNews] = useState(null);

  useEffect(() => {
    const loadArticles = async () => {
      try {
        const articles = [];
        
        // Import all 14 markdown files
        for (let i = 1; i <= 14; i++) {
          try {
            const module = await import(`../data/news/article${i}.md?raw`);
            const text = module.default || module;
            
            if (!text || typeof text !== 'string') {
              console.error(`Article ${i} content is not a string:`, text);
              continue;
            }
            
            // Parse frontmatter
            const parts = text.split('---');
            if (parts.length >= 3) {
              const frontmatter = parts[1] || '';
              const content = parts.slice(2).join('---').trim();
              
              const titleMatch = frontmatter.match(/title:\s*"([^"]*)"/);
              const dateMatch = frontmatter.match(/date:\s*"([^"]*)"/);
              
              articles.push({
                id: i,
                title: titleMatch && titleMatch[1] ? titleMatch[1] : `Article ${i}`,
                date: dateMatch && dateMatch[1] ? dateMatch[1] : new Date().toISOString().split('T')[0],
                content: content || '',
                news_text: content || ''
              });
            }
          } catch (err) {
            console.error(`Error loading article ${i}:`, err);
          }
        }
        
        // Sort by date (newest first)
        articles.sort((a, b) => new Date(b.date) - new Date(a.date));
        
        setNews(articles);
        setLoading(false);
      } catch (err) {
        console.error('Error loading articles:', err);
        setError('Failed to load news articles');
        setLoading(false);
      }
    };

    loadArticles();
  }, []);

  const openNewsModal = (newsItem) => {
    console.log('News item clicked:', newsItem);
    setSelectedNews(newsItem);
    document.body.style.overflow = 'hidden';
  };

  const closeNewsModal = () => {
    setSelectedNews(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="news">
      <Navbar />
      <div className="project-content">
        <h1 className="page-title">{t('title')}</h1>
        <div className="title-news-spacer"></div>
        
        {error && (
          <div className="error-container">
            <p className="error-message">{error}</p>
          </div>
        )}
        
        <div className="news-container">
          {news.length > 0 ? (
            news.map((item, index) => (
              <div 
                key={`${item.id || index}`}
                onClick={() => openNewsModal(item)}
                className="news-item-wrapper"
              >
                <NewsItem {...item} />
              </div>
            ))
          ) : !loading && !error && (
            <p className="no-news-message">{t('noNews')}</p>
          )}
        </div>
        {loading && <p className="loading-text">{t('loading')}</p>}
        
        {(!loading && news.length === 0) && <div className="news-page-spacer"></div>}
      </div>

      {selectedNews && (
        <div className="news-modal-overlay" onClick={closeNewsModal}>
          <div className="news-modal-content" onClick={e => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={closeNewsModal}>×</button>
            <h2 className="modal-title">{selectedNews.title || 'Untitled'}</h2>
            <div className="modal-date">{selectedNews.date || ''}</div>
            <div className="modal-content-body">
              {(() => {
                const content = selectedNews.news_text || 
                              selectedNews.content || 
                              selectedNews.main_text ||
                              selectedNews.text ||
                              'No detailed content available';
                
                if (!content || typeof content !== 'string') {
                  return <p>No content available</p>;
                }
                
                return content.split(/\n\n|\r\n\r\n/).map((paragraph, index) => {
                  const cleanParagraph = paragraph
                    .replace(/<\/?[^>]+(>|$)/g, '')
                    .trim();
                  
                  return cleanParagraph ? (
                    <p key={index} className="modal-paragraph">
                      {cleanParagraph}
                    </p>
                  ) : null;
                }).filter(Boolean);
              })()}
            </div>
          </div>
        </div>
      )}
      
      <Footer />
    </div>
  );
};

export default News;
